import { render, staticRenderFns } from "./B2CTrendChart.vue?vue&type=template&id=82b08f0c&scoped=true&"
import script from "./B2CTrendChart.vue?vue&type=script&lang=js&"
export * from "./B2CTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./B2CTrendChart.vue?vue&type=style&index=0&id=82b08f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b08f0c",
  null
  
)

export default component.exports